import React, { useEffect } from 'react';

import { Typography } from '@material-ui/core';
// eslint-disable-next-line import/named
import { Link, RouteComponentProps } from 'react-router';

import { Page } from '../../components/layouts';
// import { l10nTools } from '../../utils/tools';
import { Track } from '../../weborder/analytics';
import * as Api from '../../weborder/Api';
// import * as B from '../../weborder/BasketControl';
import {
  DispatchProps,
  StateProps,
} from '../../weborder/component/ConfigureItemHolder';
import LoadingPanel from '../../weborder/component/LoadingPanel';
import { Sorted } from '../../weborder/Data';
import * as Routes from '../../weborder/Routes';
// import { Utilities } from '../../weborder/Utilities';
import { domUtils } from '../../weborder/utils';
// import { Basket } from '../RestaurantMenu/components';
import { ConfigureItem } from './components';

type ItemRoute = RouteComponentProps<
  {
    vrid: number;
    type: 'collection' | 'delivery';
    concessionStoreId?: number;
    id: number;
    item: number;
    index: string;
  },
  {}
>;

interface ParentProps {
  parentComponent: JSX.Element;
}

type Props = StateProps & DispatchProps & ItemRoute & ParentProps;

export function RestaurantMenuOptions(props: Props): JSX.Element {
  const {
    AddItemToBasket: addItemToBasket,
    // AddToast: addToast,
    // BasketItems: basketItems,
    CollectionSummaries: collectionSummaries,
    // Customer: customer,
    DeliverySummaries: deliverySummaries,
    Item: item,
    Languages: languages,
    LoadRestaurant: loadRestaurant,
    MenuId: menuId,
    // Offset: offset,
    OptionsState: optionsState,
    params,
    // parentComponent,
    // PushLoginUrl: pushLoginUrl,
    // RemoveItemFromBasket: removeItemFromBasket,
    Restaurant: restaurant,
    SetLiveOptions: setLiveOptions,
    SetOptionsState: setOptionsState,
    translate,
  } = props;

  useEffect(() => {
    domUtils.skipToContent();
  }, []);

  useEffect(() => {
    loadRestaurant(props);
  }, [collectionSummaries, deliverySummaries]);

  const handleAddItem = (item: Api.MenuItem): (() => any) => {
    return () => {
      Track('Restaurants', 'Add Item To Basket Via Options', {
        event_label: item.Name,
        itemType: optionsState.Options.length === 0 ? 'simple' : 'complex',
        menuId: menuId,
        name: item.Name,
        virtualRestaurantId: params.vrid,
      });

      addItemToBasket({
        Item: item,
        Options: optionsState.Options,
      });

      props.router.push(Routes.ToUrl({ params }));
      // DON'T USE THIS 'NavigateTo' SHT... if we using react-router and we do then use react-router nav stuff
      // NavigateTo(Routes.ToUrl({ params }));
    };
  };

  const handleGoBack = () => {
    props.router.goBack();
  };

  //Basket Operations
  // const handleAddItemInBasket = (payload: B.Item) => {
  //   addItemToBasket(payload);
  // };

  // const handleRemoveItemFromBasket = (payload: {
  //   index: number;
  //   indexName?: string;
  //   menuId: number;
  // }) => {
  //   addToast(translate('An_item_was_removed_from_your_basket') as string);
  //   removeItemFromBasket(payload);
  // };

  // const handleBasketCheckout = () => {
  //   if (restaurant.status !== 'success') {
  //     return;
  //   }

  //   const currentLang = l10nTools.getActiveLanguage(languages, 'en');

  //   // Don't start the checkout process unless the user has enough
  //   // value in the basket.
  //   const currentBasketTotal = B.Total(basketItems.items);
  //   if (currentBasketTotal < restaurant.data.MinimumOrder) {
  //     alert(
  //       translate('Minimum_order', {
  //         restaurantName: restaurant.data.RestaurantName,
  //         amount: B.ToCurrency(
  //           restaurant.data.MinimumOrder,
  //           restaurant.data.Currency,
  //           currentLang,
  //         ),
  //       }),
  //     );
  //     return;
  //   }

  //   //Stores if alcohol is in basket
  //   let alcoholInBasket = false;

  //   //Check all items in basket for alcohol
  //   for (const item of basketItems.items) {
  //     if (item.Item.Alcohol) {
  //       alcoholInBasket = true;
  //       break;
  //     }
  //   }

  //   const next = alcoholInBasket ? 'over18' : 'checkout';
  //   const concessionStoreId = params.concessionStoreId
  //     ? '/' + params.concessionStoreId
  //     : '';
  //   let nextUrl = `/${next}/${params.vrid}/${params.type}/${params.id}${concessionStoreId}`;

  //   if (customer.status === 'success') {
  //     if (
  //       !customer.data.RequireAgeConfirmationForAlcoholOrdersData
  //         .DisplayConfirmationPrompt
  //     ) {
  //       nextUrl = `/checkout/${params.vrid}/${params.type}/${params.id}${concessionStoreId}`;
  //     }

  //     Utilities.navigateTo(nextUrl);
  //   } else {
  //     loginAndNavigateTo(); // if we are not logged in then show the login box.
  //   }
  // };

  // const loginAndNavigateTo = () => {
  //   pushLoginUrl(`/checkout/${params.vrid}/${params.type}/${params.id}`);

  //   const redirectUrl =
  //     params.type === 'delivery' ? `/phone/${params.id}` : '/phone';
  //   Utilities.navigateTo(redirectUrl);
  // };

  if (item.status !== 'success') {
    return <LoadingPanel />;
  }

  // const outsideDeliveryZone: boolean = Routes.OutsideDeliveryZone(restaurant);
  const optionSets = Sorted(item.data.MenuItemOptionSets);

  // This code is relying on the fact that we get null
  // if we index off the end, rather than doing an index check.

  const allDone = parseInt(params.index) === optionSets.length;

  let bottomBar: JSX.Element | null = null;

  if (allDone) {
    bottomBar = (
      <button
        disabled={false}
        key="done-button-bottom"
        onClick={handleAddItem(item.data)}
      >
        <Typography>{translate('Add_to_basket')}</Typography>
      </button>
    );
  }

  const backLink =
    parseInt(params.index) === 0 ? (
      <Link to={Routes.ToUrl(props)}>
        <div key="fd-nav">
          <i className="arrow_carrot-left" aria-hidden="true" />
          <u>{translate('Back')}</u>
        </div>
      </Link>
    ) : (
      <span onClick={handleGoBack}>
        <i className="arrow_carrot-left" aria-hidden="true" />
        <h4>
          <u>{translate('Back')}</u>
        </h4>
      </span>
    );

  return (
    <>
      <Page pageName="restaurant-menu-options">
        <header>
          {backLink}

          <Typography variant="h1">{item.data.Name}</Typography>
        </header>

        <article>
          <ConfigureItem
            handleAddItem={handleAddItem}
            Item={item}
            Languages={languages}
            OptionsState={optionsState}
            params={params}
            Restaurant={restaurant}
            SetLiveOptions={setLiveOptions}
            SetOptionsState={setOptionsState}
            translate={translate}
          />
        </article>

        <section>
          {/* <Basket
            AddItem={handleAddItemInBasket}
            InsideDeliveryZone={!outsideDeliveryZone}
            Items={basketItems}
            MenuId={undefined}
            Offset={offset}
            OnClick={handleBasketCheckout}
            parentComponent={parentComponent}
            RemoveItemAt={handleRemoveItemFromBasket}
            Restaurant={restaurant}
            Screen="configure"
            translate={translate}
            vrid={params.vrid}
          /> */}
        </section>
      </Page>

      {bottomBar}
    </>
  );
}
